import { createSlice } from "@reduxjs/toolkit";
import { reducerRegistry } from "@/utils/redux";
import { initialState, reducers } from "./reducers";

const slice = createSlice({
  name: "Errors",
  initialState,
  reducers,
});

export const { actions, reducer } = slice;
export const { addError } = slice.actions;

reducerRegistry.register("errors", reducer);
